import React from "react";
import clsx from "clsx";
import I18n from "i18n-js";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import NumberInput from "../../NumberSpinner/NumberSpinner";
import ErrorHelper from "../../Errors/ErrorHelper";
import PropertyDetailsBuilderErrors from "../PropertyDetailsBuilderErrors";

export default class PropertyDetailsBuilderLocks extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };

    this.onConnectRemoteLock = this.onConnectRemoteLock.bind(this);
    this.onDisconnect = this.onDisconnect.bind(this);
  }

  componentDidMount() {
    window.remote_lock_connected = (remotelock_refresh_token) => {
      this.props.onConnectRemoteLock(remotelock_refresh_token);
    };
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "locks",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="locks" style={{ position: "relative" }}>
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-12">{this.renderRemoteLockForm()}</div>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  renderRemoteLockForm() {
    if (this.props.remotelock_refresh_token) {
      return (
        <div className="row">
          <div className="col-md-4">
            <div
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                display: "inline-block",
                padding: "10px 15px",
                border: "1px solid #CFCFCF",
                marginBottom: "5px",
              }}
            >
              <strong
                style={{
                  fontWeight: "bold",
                  color: "green",
                  marginRight: "5px",
                }}
              >
                ✓{" "}
              </strong>
              {I18n.t("connected_to_your_remotelock_account")}
            </div>
            <br />
            <a href="#" onClick={this.onDisconnect}>
              {I18n.t("disconnect_your_remotelock_account")}
            </a>
          </div>
          <div className="col-md-4">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>
                {I18n.t("remotelock_grace_period")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("remotelock_grace_period_helper_text")}
                ></span>
              </label>
              <NumberInput   
                className={ErrorHelper.renderFieldClasses('remotelock_grace_period_in_minutes', this.props.errors, 'form-control')}
                name="remotelock_grace_period_in_minutes"
                value={this.props.remotelock_grace_period_in_minutes}
                onChange={this.props.onChange}
              />
            </div>
            {ErrorHelper.renderFieldErrors('remotelock_grace_period_in_minutes', this.props.errors)}
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ width: "auto", textAlign: "center" }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.onConnectRemoteLock}
          >
            {I18n.t("connect_your_remotelock_account")}
          </button>
        </div>
      );
    }
  }

  onConnectRemoteLock(e) {
    e.preventDefault();
    this.popupCenter(
      `https://connect.remotelock.com/oauth/authorize?client_id=${this.props.remotelock_client_id}&redirect_uri=${this.props.remotelock_redirect_uri}&response_type=code`,
      I18n.t("connect_your_remotelock_account"),
      625,
      388
    );
  }

  onDisconnect(e) {
    e.preventDefault();
    this.setState({ loading: true });
    $.ajax({
      type: "POST",
      url: this.props.remotelock_disconnect_path,
    }).done(() => {
      this.props.onDisconnectRemoteLock();
      this.setState({ loading: false });
    });
  }

  popupCenter(url, title, w, h) {
    // Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

    const systemZoom = 1; //width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `
      scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
    );

    if (window.focus) newWindow.focus();
  }

  renderErrors() {
    var errors = PropertyDetailsBuilderErrors.locks(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }
}
